import React from 'react';
import {Container} from 'react-bootstrap';
import img1 from '../images/8401.jpg';
import img2 from '../images/Instruction for correct pose during office work.jpg';
export default function Section4() {
  return ( 
      <section className="section2" >
        <div className=" row container-fluid col-12 d-flex ">
            <div className="intro col-sm-12 col-md-5 col-lg-5 mx-auto">
                <img src= {img1} alt="illustration" />
            </div>
            <div className="col-sm-12 col-md-6 col-lg-6 mx-auto">
                <Container> 
                    <div>
                        <hr />
                        <h1>How I Work</h1> 
                        <h6>
                            I have worked with top companies and also brands <br />to make their online presence 
                            more eye-catchy and customer friendly. <br /> I have done more than 100+ projects already.  
                        </h6>
                    </div>
                    <div>
                         <img className='wk' src={img2} alt="..." />
                    </div>
                        
                </Container>
            </div>
            
        </div> 
     </section> 
  )
}
